/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdTooltipLiteProps, TdTooltipProps } from './type';

export const tooltipDefaultProps: TdTooltipProps = {
  destroyOnClose: true,
  placement: 'top',
  showArrow: true,
  theme: 'default',
  duration: 0,
};

export const tooltipLiteDefaultProps: TdTooltipLiteProps = {
  placement: 'top',
  showArrow: true,
  showShadow: true,
  theme: 'default',
};
